import { Pipe, PipeTransform } from '@angular/core';
import { Rating } from 'src/app/shared/ratings/rating';

@Pipe({ name: 'ratingClassPipe' })
export class RatingClassPipe implements PipeTransform {

  transform(value: Rating): string {
    if (value == Rating.none)
      return "norating";
    else if (value == Rating.mustImprove)
      return "mustimprove";
    else if (value == Rating.satisfactory)
      return "satisfactory";
    else if (value == Rating.good)
      return "good";
    else if (value == Rating.outstanding)
      return "outstanding";
  }
}
